import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { faChevronLeft, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { ZoomService } from '../../../../../../../../../../../../shared/services/transactional/zoom/zoom.service';
import { finalize } from 'rxjs';
import { SpinnerService } from '../../../../../../../../../../../../shared/services/shared/spinner/spinner.service';
import { ToastService } from '../../../../../../../../../../../../shared/services/shared/toast/toast.service';
import { loadComponentTranslations } from '../../../../../../../../../../../../shared/funcs/lang-loader';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-zoom-success',
  templateUrl: './zoom-success.component.html',
  styleUrl: './zoom-success.component.scss',
  standalone: false
})
export class ZoomSuccessComponent implements OnInit {

  public faChevronLeft: IconDefinition = faChevronLeft;

  constructor(
    private _route: ActivatedRoute,
    private _zoomService: ZoomService,
    private _spinerService: SpinnerService,
    private _toastService: ToastService,
    private _router: Router,
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }


  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    loadComponentTranslations(this._http, this._translateService, 'components/organizations/organization/business-settings/integrations/zoom-success', this.isBrowser())
      .subscribe({
        next: () => {

        },
        error: () => {

        }
      });
    let state: string = this._route.snapshot.queryParams["state"];
    let userId = state?.split(" ")[0];
    let organizationId = state?.split(" ")[1];

    let code: string = this._route.snapshot.queryParams["code"];

    // if (!code) {
    //   this._router.navigate(['/auth/login']);
    //   return;
    // }

    if (!state || !userId || !organizationId || !code) {
      const returnUrl = this._route.snapshot.url.join('/') || '/auth/login';
      this._router.navigate(['/app/zoom-integration']);
      return;
    }
    this._spinerService.show("");

    this._zoomService.updateZoomCode(userId, organizationId, code)
      .pipe(
        finalize(() => this._spinerService.hide())
      )
      .subscribe(
        {
          next: response => {
            if (response.isSuccess) {
              if (response.data) {
                this._toastService.showSuccess("Zoom is integrated with your organization");
                this._router.navigate([`/app/${organizationId}/business-settings/integrations/zoom-configuration`]);
              }
            }
          }
        }
      );
  }
}
